module.exports = __webpack_public_path__ + "img/76.a0f05c20.svg";